import React, { Component } from 'react'
import Nacionalidad from './components/Nacionalidad'

export class CrearCuenta extends Component {

    render() {
        return (
			
            <Nacionalidad callTagManager={this.props.callTagManager} useEffect={this.props.useEffect}></Nacionalidad>
            )
    }
}

export default CrearCuenta
